// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"344":"50aa8365","458":"fa71a498","550":"67ee3f22","895":"5b597e35"}[chunkId] + ".chunk.js";
};